import { DeleteOutline as DeleteOutlinedIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { SummaryLabel } from 'src/components/accordion/SidebarAccordion.styled';

import { RemoveMessageTitleProps } from './RemoveMessageTitle.interface';
import { AccordionLabel } from './RemoveMessageTitle.styled';

export const RemoveMessageTitle = ({
  label,
  onClick,
}: RemoveMessageTitleProps) => {
  return (
    <AccordionLabel>
      <SummaryLabel>{label}</SummaryLabel>
      {onClick && (
        <IconButton
          sx={{ padding: 0.6 }}
          onClick={(e) => {
            e.stopPropagation();
            onClick();
          }}>
          <DeleteOutlinedIcon color="error" fontSize="small" />
        </IconButton>
      )}
    </AccordionLabel>
  );
};
